import { BrowserModule } from '@angular/platform-browser';
import { Injectable, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';

import { BrowserAnimationsModule }  from '@angular/platform-browser/animations';
import { MatTableModule }     from '@angular/material/table';

import { AgGridModule }     from 'ag-grid-angular';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ImporterComponent } from './importer/importer.component';
import { BuildingsComponent } from './buildings/buildings.component';
import { CustomersComponent } from './customers/customers.component';
import { AgreementsComponent } from './agreements/agreements.component';
import { ContractDetailComponent } from './contract-detail/contract-detail.component';
import { ContractLedgerComponent } from './contract-ledger/contract-ledger.component';
import { StaffsComponent } from './staffs/staffs.component';
import { StaffDetailDialogComponent } from './staffs/staff-detail-dialog/staff-detail-dialog.component';
import { MapDialogComponent } from './utility/map-dialog/map-dialog.component';

import { BuildingSettingComponent } from './building-setting/building-setting.component';
import { BuildingSettingDetailComponent } from './building-setting-detail/building-setting-detail.component';
import { CannotInsteadOperationDialogComponent } from './building-setting-detail/cannot-instead-operation-dialog/cannot-instead-operation-dialog.component';
import { BuildingDetailComponent } from './building-detail/building-detail.component';
import { CustomerDetailComponent } from './customer-detail/customer-detail.component';
import { AgreementDetailComponent } from './agreement-detail/agreement-detail.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './guard/auth.guard';
import { DatePipe } from '@angular/common';
import {
  MatButtonModule,
  MatMenuModule,
  MatIconModule,
  MatCardModule,
  MatDialogModule,
  MatSidenavModule,
  MatFormFieldModule,
  MatDatepickerModule,
  MatInputModule,
  MatTooltipModule,
  MatToolbarModule,
  MatPaginatorModule,
  MatSortModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatListModule,
  MatExpansionModule,
  MatBadgeModule,
  MatRadioModule,
  MatCheckboxModule,
  MatButtonToggleModule,
  MatNativeDateModule,
  MatSelectModule,
  MAT_DATE_LOCALE,
  MatSlideToggleModule
} from '@angular/material';
import { UserMasterComponent } from './user-master/user-master.component';
import { OperationComponent } from './operation/operation.component';
import { OperationDialogComponent } from './operation/operation-dialog/operation-dialog.component';
import { SmsDialogComponent } from './operation/sms-dialog/sms.component';
import { UpdateOtherTransDialogComponent } from './operation/update-other-trans-dialog/update-other-trans-dialog.component';
import { HolidayDialogComponent } from './operation/holiday-dialog/holiday-dialog.component';
import { ExchangeDialogComponent } from './operation/exchange-dialog/exchange-dialog.component';
import { ExchangeEditDialogComponent } from './operation/exchange-edit-dialog/exchange-edit-dialog.component';
import { DataConfirmDialogComponent } from './operation/data-confirm-dialog/data-confirm-dialog.component';
import { ContractDetailNoteDialogComponent } from './contract-detail/contract-detail-note-dialog/contract-detail-note-dialog.component';
import { InconsistencyDialogComponent } from './contract-detail/inconsistency-dialog/inconsistency-dialog.component';
import { AreaMasterComponent } from './area-master/area-master.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { SalaryComponent } from './salary/salary.component';
import { SalaryDialogComponent } from './salary/salary-dialog/salary-dialog.component';
import { SalaryAdjustmentDialogComponent } from './salary/salary-adjustment/salary-adjustment-dialog.component';
import { SalaryAdjustmentDayHourDialogComponent } from './salary/salary-adjustment-day-hour/salary-adjustment-day-hour-dialog.component';
import { SalaryCsvDialogComponent } from './salary/salary-csv-dialog/salary-csv-dialog.component';
import { NationalHolidayComponent } from './national-holiday/national-holiday.component';
import { NationalHolidayDialogComponent } from './national-holiday/national-holiday-dialog/national-holiday-dialog.component';
import { BuildingsExportDialogComponent } from './buildings/buildings-export-dialog/buildings-export-dialog.component';
import { PaidHolidayComponent } from './paid-holiday/paid-holiday.component';
import { ExportHistoryDialogComponent } from './paid-holiday/export-history-dialog/export-history-dialog.component';
import { DaysEditDialogComponent } from './paid-holiday/days-edit-dialog/days-edit-dialog.component';
import { ImportReportDialogComponent } from './confirmation/import-report-dialog/import-report-dialog.component';
import { RecruitComponent } from './recruit/recruit.component';
import { VacancyComponent } from './vacancy/vacancy.component';
import { ShortageTimeComponent } from './shortage-time/shortage-time.component';
import { MobileZoomComponent } from './common/mobile-zoom/mobile-zoom.component';
import { LogComponent } from './log/log.component';
import { YearMonthDatepickerComponent } from './year-month-datepicker/year-month-datepicker.component';
import { ManagementPlanDialogComponent } from './agreements/management-plan-dialog/management-plan.component';
import { ClientSelectionDialogComponent } from './agreements/client-selection-dialog/client-selection.component';
import { AddressPrintDialogComponent } from './common/address-print-dialog/address-print-dialog.component';
import { AddressLabelPositionDialogComponent } from './common/address-label-position-dialog/address-label-position-dialog.component';

@Injectable()
export class NoCacheHeadersInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const authReq = req.clone({
            setHeaders: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache'
            }
        });
        return next.handle(authReq);    
    }
}
@NgModule({
  declarations: [
    AppComponent,
    ImporterComponent,
    BuildingsComponent,
    CustomersComponent,
    AgreementsComponent,
    ContractDetailComponent,
    ContractLedgerComponent,
    StaffsComponent,
    StaffDetailDialogComponent,
    MapDialogComponent,
    BuildingSettingComponent,
    BuildingDetailComponent,
    BuildingSettingDetailComponent,
    CannotInsteadOperationDialogComponent,
    CustomerDetailComponent,
    AgreementDetailComponent,
    LoginComponent,
    UserMasterComponent,
    OperationComponent,
    OperationDialogComponent,
    SmsDialogComponent,
    UpdateOtherTransDialogComponent,
    HolidayDialogComponent,
    ExchangeDialogComponent,
    ExchangeEditDialogComponent,
    DataConfirmDialogComponent,
    ContractDetailNoteDialogComponent,
    InconsistencyDialogComponent,
    AreaMasterComponent,
    ConfirmationComponent,
    SalaryComponent,
    SalaryDialogComponent,
    SalaryAdjustmentDialogComponent,
    SalaryAdjustmentDayHourDialogComponent,
    SalaryCsvDialogComponent,
    NationalHolidayComponent,
    NationalHolidayDialogComponent,
    BuildingsExportDialogComponent,
    PaidHolidayComponent,
    ExportHistoryDialogComponent,
    DaysEditDialogComponent,
    ImportReportDialogComponent,
    RecruitComponent,
    VacancyComponent,
    ShortageTimeComponent,
    MobileZoomComponent,
    LogComponent,
    YearMonthDatepickerComponent,
    ManagementPlanDialogComponent,
    ClientSelectionDialogComponent,
    AddressPrintDialogComponent,
    AddressLabelPositionDialogComponent
  ],
  imports: [
    AppRoutingModule,
    AgGridModule.withComponents([]),
    BrowserModule,
    BrowserAnimationsModule,
    MatTableModule,
    FormsModule,
    HttpClientModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatCardModule,
    MatDatepickerModule,
    MatSidenavModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatToolbarModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressBarModule,
    MatListModule,  
    MatExpansionModule,
    MatBadgeModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatNativeDateModule,
    MatSelectModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    MatSnackBarModule
  ],
  exports: [
    MatTableModule,
    MatPaginatorModule,  
    MatExpansionModule,
    MatBadgeModule,
    MatProgressSpinnerModule,
    MatDialogModule
  ],
  entryComponents: [
    CannotInsteadOperationDialogComponent,
    OperationDialogComponent,
    SmsDialogComponent,
    UpdateOtherTransDialogComponent,
    HolidayDialogComponent,
    ExchangeDialogComponent,
    ExchangeEditDialogComponent,
    DataConfirmDialogComponent,
    ContractDetailNoteDialogComponent,
    InconsistencyDialogComponent,
    SalaryDialogComponent,
    SalaryAdjustmentDialogComponent,
    SalaryAdjustmentDayHourDialogComponent,
    SalaryCsvDialogComponent,
    NationalHolidayDialogComponent,
    BuildingsExportDialogComponent,
    ImportReportDialogComponent,
    StaffDetailDialogComponent,
    MapDialogComponent,
    ManagementPlanDialogComponent,
    ClientSelectionDialogComponent,
    AddressPrintDialogComponent,
    ExportHistoryDialogComponent,
    DaysEditDialogComponent,
    AddressLabelPositionDialogComponent
  ],
  providers: [
    AuthGuard,
    DatePipe,
    {provide: MAT_DATE_LOCALE, useValue: 'ja-JP'},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoCacheHeadersInterceptor,
      multi: true
    },
  ],

  bootstrap: [ AppComponent ]
})
export class AppModule { }


